function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 402.393 402.393",
  style: {
    "enableBackground": "new 0 0 402.393 402.393"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFD7A3"
  },
  d: "M128.903,243.947c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 l-72.113,80.771L128.903,243.947z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDC88E"
  },
  d: "M247.258,272.075l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H141.973 C150.471,224.124,206.68,266.043,247.258,272.075z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#0087A1"
  },
  d: "M352.544,402.393c10.903,0,19.741-8.838,19.741-19.741v-58.949 c0-28.954-22.562-59.864-50.138-68.687l-41.168-13.173c-22.149,16.936-53.802,40.039-79.782,40.039s-57.633-23.103-79.782-40.039 l-41.168,13.173c-27.576,8.823-50.138,39.733-50.138,68.687v58.949c0,10.903,8.838,19.741,19.741,19.741H352.544z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#007998"
  },
  d: "M201.196,281.881l-27.456,27.456c-2.859,2.859-7.596,2.487-9.975-0.783l-48.113-66.156 l15.326-15.326c2.475-2.475,6.454-2.579,9.055-0.238L201.196,281.881z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#007998"
  },
  d: "M201.196,281.881l27.456,27.456c2.859,2.859,7.596,2.487,9.975-0.783l48.113-66.156l-15.326-15.326 c-2.475-2.475-6.454-2.579-9.055-0.238L201.196,281.881z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#ADB4BA"
  },
  d: "M313.062,251.251l-26.321-8.423v80.969c0,3.012-1.999,5.675-4.923,6.395 c-22.275,5.486-50.216,8.77-80.621,8.77s-58.346-3.284-80.621-8.77c-2.925-0.72-4.923-3.383-4.923-6.395v-80.969l-26.321,8.423 v151.142h223.731V251.251z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M293.231,112.002c0,52.696-30.343,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 c0-44.965,25.4-106.136,92.124-106.136C274.685,5.867,293.231,59.306,293.231,112.002z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M112.147,125.163c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 C136.977,143.67,112.147,125.163,112.147,125.163z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M288.57,125.163c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S288.57,125.163,288.57,125.163z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A0756F"
  },
  d: "M108.342,135.828c-4.935-18.918-12.484-84.348,2.468-103.366 c19.831-25.225,38.217-5.559,38.217-5.559l1.265,41.065l-30.16,72.521L108.342,135.828z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A0756F"
  },
  d: "M232.339,3.638c-57.464-12.104-86.097,9.202-96.833,17.294c-1.006,0.758-1.776,1.437-2.297,2.007 l17.081,44.341c47.296,23.668,95.826,25.329,95.826,25.329l5.972-28.896l30.425,75.884l11.29-3.804c0,0,5.367-54.81,6.19-67.681 S288.086,15.38,232.339,3.638z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 103.756,
  y: 96.787,
  style: {
    "fill": "#29394A"
  },
  width: 22.858,
  height: 30.37
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 275.779,
  y: 96.787,
  style: {
    "fill": "#29394A"
  },
  width: 22.858,
  height: 30.37
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#455465"
  },
  d: "M268.215,57.478H134.178c-11.93,0-21.355,9.717-20.508,21.142l8.968,120.986 c1.787,24.109,22.679,42.792,47.853,42.792h61.413c25.174,0,46.066-18.683,47.853-42.792l8.968-120.986 C289.57,67.195,280.145,57.478,268.215,57.478z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#52A9CF"
  },
  d: "M261.516,143.358c0,3.619-2.961,6.58-6.58,6.58H147.457c-3.619,0-6.58-2.961-6.58-6.58v-18.227 c0-3.619,2.961-6.58,6.58-6.58h107.479c3.619,0,6.58,2.961,6.58,6.58V143.358z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#29394A"
  },
  d: "M254.934,156.517H147.458c-7.258,0-13.161-5.906-13.161-13.161v-18.224 c0-7.255,5.902-13.161,13.161-13.161h107.476c7.258,0,13.161,5.906,13.161,13.161v18.224 C268.095,150.612,262.193,156.517,254.934,156.517z M147.458,125.132v18.224h107.476v-18.224H147.458z"
})))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/7.4040a0eb.svg";
export { SvgComponent as ReactComponent };